import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=448f1daf&scoped=true"
import script from "./MenuBar.vue?vue&type=script&lang=ts"
export * from "./MenuBar.vue?vue&type=script&lang=ts"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=448f1daf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448f1daf",
  null
  
)

export default component.exports